import * as React from "react";
import { forwardRef } from "react";
const SvgMoreMenu = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "Property 1=24" }, /* @__PURE__ */ React.createElement("circle", { id: "Ellipse 8", cx: 12, cy: 6, r: 2, fill: "currentColor" }), /* @__PURE__ */ React.createElement("circle", { id: "Ellipse 9", cx: 12, cy: 12, r: 2, fill: "currentColor" }), /* @__PURE__ */ React.createElement("circle", { id: "Ellipse 10", cx: 12, cy: 18, r: 2, fill: "currentColor" })));
const ForwardRef = forwardRef(SvgMoreMenu);
export default ForwardRef;
